/*
自动生成代码，请不要手工修改
create at 2025&#x2F;6&#x2F;1909:39:25
*/
import {
  AddRecordToStudent,
  ApiResponseData,
  BaseEntityOfGuid,
  BaseTrainingSchedule,
  BatchAduitDto,
  BatchAuditDeleteApplyDto,
  BatchDeleteIdsModel,
  ClassSigninDto,
  ClassSolutionMobile,
  ClassState,
  CommonAuditStatus,
  Comparator,
  ComperhensiveEvaluationDto,
  CourseEvaluationDto,
  CourseForm,
  DeleteAuditStatus,
  DeptPlanClassDto,
  EditLeaveDto,
  EditTrainClassDto,
  EvaluationLevel,
  HoursType,
  IDModel,
  IDModelString,
  IPagedList,
  IdsModel,
  ImportProvinceCadreTrainRecordDto,
  ImportTrainStudentDto,
  LeaveAuditorDto,
  LoginResult,
  MarkProblemDto,
  PersonalTrainSummary,
  PlatformValidateCode,
  PostRank,
  ProblemBase,
  ProblemDto,
  ProblemImportance,
  ProvinceCadreDto,
  ReplyProblemDto,
  ResetPasswordDto,
  SelfPlanType,
  SelfTrainPlanAuditStatus,
  SendSmsToDept,
  Sex,
  SignUpDto,
  SmsType,
  StorageTrainingSchedule,
  StudentInfoDto,
  StudentRoomBase,
  StudentRoomDto,
  TeacherEvaluationDto,
  TimeSlot,
  TrainClassDto,
  TrainRecordBaseDto,
  TrainRecordDto,
  TrainRecordType,
  TraineeOpenId,
  TrainingAgencyDto,
  TrainingClassLeave,
  TrainingClassLeaveDto,
  TrainingClassLevel,
  TrainingClassType,
  TrainingLevelTree,
  TrainingScheduleDto,
  TrainingScheduling,
  TreeNode,
  UpdatePrintTagDto,
  UpdateTraineeInfoDto,
  UploadStudentManualDto,
  UserExtends,
  UserOnlineCountHours,
  UserOnlineCourse,
  UserOnlineCourseDetails,
  UserType,
  WeixinLoginReslut,
} from './models';
import { apiSendAsync } from '@/utils/apiRequest';

// tslint:disable-next-line:no-namespace
export namespace Notices {
  /**
   * 短信提醒未查看通知单位
   */
  export async function sendSmsToDepts_POST(
    model: SendSmsToDept,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/Notices/SendSmsToDepts', model, query);
  }
}
// tslint:disable-next-line:no-namespace
export namespace PlanOfClass {
  /**
   * 记录打印培训班报到二维码标记
   */
  export async function updatePrintTag_POST(
    model: UpdatePrintTagDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/PlanOfClass/UpdatePrintTag', model, query);
  }

  /**
   * 上传培训评估结果
   */
  export async function uploadEvaluationResultsFile_POST(
    model: UploadStudentManualDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/PlanOfClass/UploadEvaluationResultsFile', model, query);
  }

  /**
   * 上传学员手册
   */
  export async function uploadStudentManual_POST(
    model: UploadStudentManualDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/PlanOfClass/UploadStudentManual', model, query);
  }

  export async function getCourses_GET(query?: { startDate?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/PlanOfClass/GetCourses', null, query);
  }

  /**
   * 更新设置课程评价开关
   */
  export async function updateCourseEvaluation_POST(
    model: CourseEvaluationDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/PlanOfClass/UpdateCourseEvaluation', model, query);
  }

  /**
   * 根据id单独删除日程
   */
  export async function deleteTrainingScheduleById_POST(
    model: IDModel,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/PlanOfClass/DeleteTrainingScheduleById', model, query);
  }

  /**
   * 根据班级Id查找日程信息
   */
  export async function findTrainingSchedules_GET(query: {
    classId?: string | undefined;
    tag?: boolean | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/PlanOfClass/FindTrainingSchedules', null, query);
  }

  /**
   * 独立保存培训计划日程
   */
  export async function saveTrainingSchedules_POST(
    model: StorageTrainingSchedule,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/PlanOfClass/SaveTrainingSchedules', model, query);
  }
}
// tslint:disable-next-line:no-namespace
export namespace SelfTrainPlan {
  /**
   * 培训计划办班情况导出
   */
  export async function exportTrainPlans_GET(query?: {
    /** 年度 */

    year?: number | undefined /** 申报单位id */;
    deptId?: string | undefined /** 培训计划审核状态 */;
    auditStatus?: SelfTrainPlanAuditStatus | undefined /** 培训类型：政治理论、党性教育、专业化能力、其他 */;
    trainType?: string | undefined /** 计划类型：培训班、案例工作、网络学习、行动学习 */;
    type?: SelfPlanType | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/SelfTrainPlan/ExportTrainPlans', null, query);
  }

  /**
   * 一键批量审核单位删除培训计划申请
   */
  export async function auditDeletePlan_POST(
    model: BatchAuditDeleteApplyDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/SelfTrainPlan/AuditDeletePlan', model, query);
  }
}
// tslint:disable-next-line:no-namespace
export namespace User {
  /**
   * 重置密码
   */
  export async function resetPassword_POST(
    model: ResetPasswordDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/User/ResetPassword', model, query);
  }
}
// tslint:disable-next-line:no-namespace
export namespace AccountApp {
  /**
   * 同步干部职级信息
   */
  export async function syncPostRank_GET(query?: { [key: string]: any }) {
    return apiSendAsync<ApiResponseData<number>>('GET', '/api/AccountApp/SyncPostRank', null, query);
  }

  /**
   * 同步干部职级信息
   */
  export async function syncPostRank_POST(query?: { [key: string]: any }) {
    return apiSendAsync<ApiResponseData<number>>('POST', '/api/AccountApp/SyncPostRank', null, query);
  }

  /**
   * 同步学员端单位代码
   */
  export async function syncDeptCode_POST(query?: { [key: string]: any }) {
    return apiSendAsync<ApiResponseData<boolean>>('POST', '/api/AccountApp/SyncDeptCode', null, query);
  }

  /**
   * 获取学员的网院总学时
   */
  export async function getStudentOnlineCountHours_GET(query?: {
    userIds?: string | undefined /** 年度 */;
    year?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<UserOnlineCountHours[]>>(
      'GET',
      '/api/AccountApp/GetStudentOnlineCountHours',
      null,
      query
    );
  }

  /**
   * 获取学员的网院学习情况
   */
  export async function getStudentOnlineHoursDetails_GET(query: {
    /** 网院用户的id */

    userIds?: string | undefined /** 开始时间 */;
    startDate?: string | undefined /** 截止时间 */;
    endDate?: string | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<UserOnlineCourseDetails>>(
      'GET',
      '/api/AccountApp/GetStudentOnlineHoursDetails',
      null,
      query
    );
  }

  /**
   * 获取用户培训天数 （默认不传年份时则获取近五年培训天数，如需获取某一年培训天数起始与截至年份传相同值即可）
   */
  export async function getTrainDays_GET(query?: {
    startYear?: number | undefined;
    endYear?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<PersonalTrainSummary>>('GET', '/api/AccountApp/GetTrainDays', null, query);
  }

  export async function getQrCode_GET(query: {
    url?: string | undefined;
    pixel?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/AccountApp/GetQRCode', null, query);
  }

  export async function getAuthUrl_GET(query?: {
    classId?: string | undefined;
    opreateType?: string | undefined;
    classType?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<string>>('GET', '/api/AccountApp/GetAuthUrl', null, query);
  }

  /**
   * 修改手机号
   */
  export async function updatePhone_POST(query?: {
    Phone?: string | undefined;
    VerCode?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<boolean>>('POST', '/api/AccountApp/UpdatePhone', null, query);
  }

  /**
   * 电脑端短信验证码登录
   */
  export async function smsLogin_POST(
    model: PlatformValidateCode,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/AccountApp/SmsLogin', model, query);
  }

  /**
   * 手机短信验证码验证
   */
  export async function validateCode_POST(query?: {
    Phone?: string | undefined;
    VerCode?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<boolean>>('POST', '/api/AccountApp/ValidateCode', null, query);
  }

  export async function getAccessToken_GET(query?: { [key: string]: any }) {
    return apiSendAsync<ApiResponseData<string>>('GET', '/api/AccountApp/GetAccessToken', null, query);
  }

  export async function sendSms_POST(query?: { Phone?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<boolean>>('POST', '/api/AccountApp/SendSms', null, query);
  }

  export async function localSendSms_POST(query: {
    Phone?: string | undefined;
    Type?: SmsType | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<boolean>>('POST', '/api/AccountApp/LocalSendSms', null, query);
  }

  /**
   * 后期绑定网院账号接口
   */
  export async function platformBind_POST(query?: {
    UserName?: string | undefined;
    Password?: string | undefined;
    Captcha?: string | undefined;
    Phone?: string | undefined;
    WxOpenId?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<WeixinLoginReslut>>('POST', '/api/AccountApp/PlatformBind', null, query);
  }

  /**
   * 根据Authkey自动登录
   */
  export async function autoLoginByAuthkey_POST(query?: { authKey?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<WeixinLoginReslut>>('POST', '/api/AccountApp/AutoLoginByAuthkey', null, query);
  }

  /**
   * 本地无网院账号模式注册
   */
  export async function localRegister_POST(query: {
    /** 用户名 */

    Username?: string | undefined /** 手机号 */;
    Phone?: string | undefined /** 验证码 */;
    VerCode?: string | undefined /** 姓名 */;
    Name?: string | undefined /** 性别 */;
    Sex?: string | undefined /** 出生年月 */;
    Birthday?: string | undefined /** 民族 */;
    Nation?: string | undefined /** 政治面貌 */;
    Political?: string | undefined /** 主管单位Id */;
    OrgId?: string | undefined /** 工作单位（必填） */;
    WorkUnit?: string | undefined /** 工作单位所在地市 */;
    City?: string | undefined /** 职务（必填） */;
    Job?: string | undefined /** 职级(领导职务职级，如：厅局级正职、县处级正职) */;
    PostRank?: number | undefined /** 职级（综合管理类职级，如：巡视员、调研员等） */;
    UnManageRank?: number | undefined /** OpenId */;
    OpenId?: string | undefined /** 签名数据 */;
    Signature?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<WeixinLoginReslut>>('POST', '/api/AccountApp/LocalRegister', null, query);
  }

  /**
   * 新的网院平台注册接口
   */
  export async function platformRegisterNew_POST(query?: {
    AuthKey?: string | undefined;
    UserName?: string | undefined;
    Pwd?: string | undefined;
    Phone?: string | undefined;
    VerCode?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<WeixinLoginReslut>>('POST', '/api/AccountApp/PlatformRegisterNew', null, query);
  }

  export async function login_POST(query?: {
    Phone?: string | undefined;
    Accesstoken?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/AccountApp/Login', null, query);
  }

  /**
   * 删除学员并取消绑定操作
   */
  export async function removeTrainee_POST(
    mode: IDModel,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<boolean>>('POST', '/api/AccountApp/RemoveTrainee', mode, query);
  }

  /**
   * 获取学员个人信息
   */
  export async function getUserPersonalInfo_GET(query?: { id?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/AccountApp/GetUserPersonalInfo', null, query);
  }

  export async function editStudentInfo_POST(
    model: StudentInfoDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/AccountApp/EditStudentInfo', model, query);
  }

  export async function getAllDepts_GET(query?: { [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/AccountApp/GetAllDepts', null, query);
  }

  /**
   * 获取个人总的线下和线上学时
   */
  export async function getSumDays_GET(query?: {
    /** 年度 （年度为空时为全部年份） */

    year?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/AccountApp/GetSumDays', null, query);
  }

  /**
   * 获取个人培训记录
   */
  export async function getMyTrainRecordsByYear_GET(query?: {
    /** 年度(获取全部时，传null) */

    year?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/AccountApp/GetMyTrainRecordsByYear', null, query);
  }

  /**
   * 获取个人网络学院线上学时
   */
  export async function getMyOnlineHoursDetails_GET(query: {
    startDate?: string | undefined;
    endDate?: string | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<UserOnlineCourseDetails>>(
      'GET',
      '/api/AccountApp/GetMyOnlineHoursDetails',
      null,
      query
    );
  }
}
// tslint:disable-next-line:no-namespace
export namespace ClassSolution {
  /**
   * 更新待报名培训班已读状态
   */
  export async function setReaded_POST(
    model: IDModel,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/ClassSolution/SetReaded', model, query);
  }

  /**
   * 设置培训班请假审核人
   */
  export async function saveLeaveAuditor_POST(
    model: LeaveAuditorDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/ClassSolution/SaveLeaveAuditor', model, query);
  }

  /**
   * 删除打印报到二维码生成的培训班
   */
  export async function deleteDeptPlanClass_POST(
    model: BatchDeleteIdsModel,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/ClassSolution/DeleteDeptPlanClass', model, query);
  }

  /**
   * 打印报到二维码时快捷修改部分信息
   */
  export async function saveClassInfo_POST(
    model: EditTrainClassDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/ClassSolution/SaveClassInfo', model, query);
  }

  /**
   * 保存编辑根据培训计划生成的打印报到二维码培训班信息
   */
  export async function saveDeptPlanClass_POST(
    model: DeptPlanClassDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/ClassSolution/SaveDeptPlanClass', model, query);
  }

  /**
   * 根据培训计划id获取相关的培训班
   */
  export async function getClassByPlanId_GET(query: { planId?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/ClassSolution/GetClassByPlanId', null, query);
  }

  /**
   * 根据培训班id获取学员请假记录
   */
  export async function getLeavesByClassId_GET(query: {
    classId?: string | undefined /** 单位端审核状态 */;
    status?: CommonAuditStatus | undefined /** 干教处审核状态 */;
    adminStatus?: CommonAuditStatus | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/ClassSolution/GetLeavesByClassId', null, query);
  }

  /**
   * 获取学员个人请假记录
   */
  export async function getMyLeaves_GET(query?: { [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/ClassSolution/GetMyLeaves', null, query);
  }

  /**
   * 管理端-批量审核培训班报名学员
   */
  export async function batchAduit_POST(
    model: BatchAduitDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/ClassSolution/BatchAduit', model, query);
  }

  /**
   * 管理端-获取本单位所有培训班的所有学员列表 也可以根据某一个培训班id获取
   */
  export async function getMyDeptSigninStudents_GET(query: {
    solutionId?: string | undefined;
    year?: number | undefined;
    className?: string | undefined;
    state?: CommonAuditStatus | undefined;
    studentName?: string | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/ClassSolution/GetMyDeptSigninStudents', null, query);
  }

  export async function getStudentAuditStatus_GET(query: {
    studentId?: string | undefined;
    classIds?: string[] | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/ClassSolution/GetStudentAuditStatus', null, query);
  }

  /**
   * 移动端-培训班报名接口
   */
  export async function studentSignUp_POST(
    model: SignUpDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/ClassSolution/StudentSignUp', model, query);
  }

  /**
   * 移动端-根据不同状态和条件查询办班方案信息
   */
  export async function findClassSolutions_GET(query: {
    state?: ClassState | undefined;
    name?: string | undefined;
    trainType?: string | undefined;
    classType?: string | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<IPagedList<TrainClassDto>>>(
      'GET',
      '/api/ClassSolution/FindClassSolutions',
      null,
      query
    );
  }

  /**
   * 管理端-保存办班方案报名时间设置
   */
  export async function save_POST(
    model: ClassSolutionMobile,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/ClassSolution/Save', model, query);
  }

  /**
   * 根据id获取培训班详细信息
   */
  export async function findOneById_GET(query: {
    id?: string | undefined;
    type?: TrainingClassType | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<TrainClassDto>>('GET', '/api/ClassSolution/FindOneById', null, query);
  }

  export async function getPendingClassCounts_GET(query?: { [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/ClassSolution/GetPendingClassCounts', null, query);
  }
}
// tslint:disable-next-line:no-namespace
export namespace ComperhensiveEvaluation {
  /**
   * 保存&#x2F;修改综合评价信息
   */
  export async function save_POST(
    model: ComperhensiveEvaluationDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/ComperhensiveEvaluation/Save', model, query);
  }

  /**
   * 删除综合评价
   */
  export async function deletes_POST(
    model: BatchDeleteIdsModel,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/ComperhensiveEvaluation/Deletes', model, query);
  }

  /**
   * 查询所有综合评价信息
   */
  export async function getAll_GET(query: {
    /** 培训班名称 */

    className?: string | undefined /** 学生姓名 */;
    studentName?: string | undefined /** 培训机构名称 */;
    trainingAgencyName?: string | undefined /** 培训机构id */;
    trainingAgencyId?: string | undefined /** 办班方案id */;
    openClassSolutionId?: string | undefined /** 学员id */;
    studentId?: string | undefined /** 办班方案部门id */;
    deptId?: string | undefined /** 评价内容 */;
    content?: string | undefined /** pageIndex */;
    pageIndex?: number | undefined /** pageSize */;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/ComperhensiveEvaluation/GetAll', null, query);
  }

  /**
   * 根据培训班Id获取培训班的综合评价信息
   */
  export async function getComperhensiveEvaluationByClassId_GET(query: {
    /** 培训班id */

    classId?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>(
      'GET',
      '/api/ComperhensiveEvaluation/GetComperhensiveEvaluationByClassId',
      null,
      query
    );
  }

  /**
   * 获取个人综合评价
   */
  export async function getMyCommented_GET(query: {
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/ComperhensiveEvaluation/GetMyCommented', null, query);
  }

  /**
   * 获取个人待综合评价
   */
  export async function getMyWaitEvaluate_GET(query: {
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/ComperhensiveEvaluation/GetMyWaitEvaluate', null, query);
  }
}
// tslint:disable-next-line:no-namespace
export namespace Experience {
  /**
   * 根据培训班Id获取学员的上课心得
   */
  export async function getExperienceByClassId_GET(query: {
    /** 培训班id */

    classId?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Experience/GetExperienceByClassId', null, query);
  }

  /**
   * 删除个人心得
   */
  export async function deletes_POST(
    model: BatchDeleteIdsModel,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/Experience/Deletes', model, query);
  }

  /**
   * 移动端-获取个人已提交的所有心得
   */
  export async function getMyExperiences_GET(query?: { [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Experience/GetMyExperiences', null, query);
  }

  /**
   * 移动端-获取个人待提交的上课心得培训班
   */
  export async function getWaitSubmitExperiences_GET(query?: { [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Experience/GetWaitSubmitExperiences', null, query);
  }

  /**
   * 管理端-获取所有提交的上课心得
   */
  export async function getAllExperiences_GET(query: {
    keyword?: string | undefined;
    studentName?: string | undefined;
    className?: string | undefined;
    solutionId?: string | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Experience/GetAllExperiences', null, query);
  }

  /**
   * 上课心得保存接口
   */
  export async function save_POST(query: {
    Id?: string | undefined;
    ClassType?: TrainingClassType | undefined;
    ClassId?: string | undefined;
    ClassName?: string | undefined;
    Description?: string | undefined;
    AttachmentKey?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/Experience/Save', null, query);
  }
}
// tslint:disable-next-line:no-namespace
export namespace Leaves {
  export async function getPhoneByTraineeId_GET(query: { id?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Leaves/GetPhoneByTraineeId', null, query);
  }

  /**
   * 导入单位请假记录
   */
  export async function importDeptLeaves_POST(query?: { [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/Leaves/ImportDeptLeaves', null, query);
  }

  /**
   * 导入请假记录
   */
  export async function importLeaves_POST(query?: { [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/Leaves/ImportLeaves', null, query);
  }

  /**
   * 补充请假记录的工作单位、职务、职级信息
   */
  export async function complementLeaveInfo_POST(query?: { [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/Leaves/ComplementLeaveInfo', null, query);
  }

  /**
   * 参训情况统计
   */
  export async function getTrainCount_GET(query: {
    /** 年度 */

    year?: number | undefined /** 单位类型标签 支持多个 多个用逗号隔开 如：区直单位,高校 */;
    orgTypes?: string | undefined /** 学员岗位职级 */;
    postRank?: PostRank | undefined /** 培训班类型 暂时不用 */;
    classType?: string | undefined /** 培训班开始日期 */;
    trainStartDate?: string | undefined /** 培训班截止日期 */;
    trainEndDate?: string | undefined /** 是否只查本单位 */;
    isMyDept?: boolean | undefined /** 是否导出 默认传false 导出时传true */;
    isExport?: boolean | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Leaves/GetTrainCount', null, query);
  }

  /**
   * 修改部分请假信息（单位端和干教处共用）
   */
  export async function editLeaveInfo_POST(
    model: EditLeaveDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/Leaves/EditLeaveInfo', model, query);
  }

  /**
   * 手机端获取需要我审核的请假信息
   */
  export async function findMyAuditLeaves_GET(query: {
    /** 组织单位审核状态 */

    orgAuditStatus?: CommonAuditStatus | undefined /** 干教处审核状态 */;
    auditStatus?: CommonAuditStatus | undefined /** 培训班名称 */;
    className?: string | undefined /** 请假开始时间 */;
    startDate?: string | undefined /** 请假截止时间 */;
    endDate?: string | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Leaves/FindMyAuditLeaves', null, query);
  }

  /**
   * 组织培训单位-批量审核请假记录（手机端通用）
   */
  export async function orgBatchAduit_POST(
    model: BatchAduitDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/Leaves/OrgBatchAduit', model, query);
  }

  /**
   * 干教处-批量审核请假记录 (手机端共用)
   */
  export async function adminBatchAduit_POST(
    model: BatchAduitDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/Leaves/AdminBatchAduit', model, query);
  }

  /**
   * 根据姓名获取学员信息
   */
  export async function getTraineesByName_GET(query?: { name?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Leaves/GetTraineesByName', null, query);
  }

  export async function getStudentsByClassId_GET(query: {
    classId?: string | undefined;
    classType?: TrainingClassType | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Leaves/GetStudentsByClassId', null, query);
  }

  /**
   * 干教管理端录入学员请假记录时 先查询选择培训班
   */
  export async function findClassByName_GET(query?: { name?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Leaves/FindClassByName', null, query);
  }

  export async function findByIds_POST(
    model: IdsModel,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/Leaves/FindByIds', model, query);
  }

  export async function findOneById_GET(query: { id?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Leaves/FindOneById', null, query);
  }

  /**
   * 干教处与单位端共用的删除请假记录接口
   */
  export async function deletes_POST(
    model: IdsModel,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/Leaves/Deletes', model, query);
  }

  /**
   * 干教处和单位端共用录入编辑请假接口
   */
  export async function save_POST(
    model: TrainingClassLeaveDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<TrainingClassLeave>>('POST', '/api/Leaves/Save', model, query);
  }

  /**
   * 移动端-获取学员的所有请假记录
   */
  export async function findMyLeaves_GET(query: {
    /** 是否做了退学处理 */

    IsDropOut?: boolean | undefined;
    className?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Leaves/FindMyLeaves', null, query);
  }

  /**
   * 移动端-用户删除取消请假
   */
  export async function mobileCancel_POST(query: { Id?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<boolean>>('POST', '/api/Leaves/MobileCancel', null, query);
  }

  /**
   * 移动端-用户录入&#x2F;编辑请假信息
   */
  export async function mobileSave_POST(query: {
    ClassType?: TrainingClassType | undefined;
    PublicTrainingClassId?: string | undefined;
    ClassName?: string | undefined;
    StartTime?: string | undefined;
    StartTimeSlot?: TimeSlot | undefined;
    EndTime?: string | undefined;
    EndTimeSlot?: TimeSlot | undefined;
    Days?: number | undefined;
    Reason?: string | undefined;
    AttachmentKey?: string | undefined;
    Id?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<TrainingClassLeave>>('POST', '/api/Leaves/MobileSave', null, query);
  }

  /**
   * 单位端查询请假记录
   */
  export async function findDeptLeaves_GET(query: {
    /** 是否本单位自己创建申请的请假信息 */

    isMyCreate?: boolean | undefined /** 干教处审核状态 */;
    auditStatus?: CommonAuditStatus | undefined;
    orgAuditState?: CommonAuditStatus | undefined /** 学员姓名 */;
    name?: string | undefined /** 是否做了退学处理 */;
    IsDropOut?: boolean | undefined /** 培训班名称 */;
    className?: string | undefined /** 请假开始日期 */;
    startDate?: string | undefined /** 请假截止日期 */;
    endDate?: string | undefined /** 请假提交开始日期 */;
    startCreateOn?: string | undefined /** 请假提交截止日期 */;
    endCreateOn?: string | undefined /** 年度 */;
    year?: number | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Leaves/FindDeptLeaves', null, query);
  }

  /**
   * 干教管理端查询请假记录
   */
  export async function findLeaves_GET(query: {
    /** 是否导出 */

    isExport?: boolean | undefined /** 是否查询所有请假记录（含盖仅需组织单位审核的） */;
    isAll?: boolean | undefined /** 主管单位id */;
    deptId?: string | undefined /** 干教处审核状态 */;
    auditStatus?: CommonAuditStatus | undefined /** 组织培训单位审核状态 */;
    orgAuditState?: CommonAuditStatus | undefined /** 学员姓名 */;
    name?: string | undefined /** 是否做了退学处理 */;
    IsDropOut?: boolean | undefined /** 培训班名称 */;
    className?: string | undefined /** 请假开始日期 */;
    startDate?: string | undefined /** 请假截止日期 */;
    endDate?: string | undefined /** 请假提交开始日期 */;
    startCreateOn?: string | undefined /** 请假提交截止日期 */;
    endCreateOn?: string | undefined /** 年度 */;
    year?: number | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Leaves/FindLeaves', null, query);
  }
}
// tslint:disable-next-line:no-namespace
export namespace Problem {
  /**
   * 管理端-查看所有问题
   */
  export async function findAll_GET(query: {
    category?: string | undefined;
    className?: string | undefined;
    keyword?: string | undefined;
    classId?: string | undefined;
    importance?: ProblemImportance | undefined;
    isSolved?: boolean | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Problem/FindAll', null, query);
  }

  /**
   * 查看个人所有提交问题
   */
  export async function findMyProblems_GET(query: {
    category?: string | undefined;
    className?: string | undefined;
    classId?: string | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Problem/FindMyProblems', null, query);
  }

  /**
   * 手机端-根据培训班id查找个人提交的所有问题
   */
  export async function findByClassIdAndUserId_GET(query: { classId?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Problem/FindByClassIdAndUserId', null, query);
  }

  /**
   * 管理端-根据培训班ID查看当前培训班所有问题
   */
  export async function findByClassId_GET(query: { classId?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Problem/FindByClassId', null, query);
  }

  /**
   * 根据Id查找问题信息
   */
  export async function findOneById_GET(query: { id?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Problem/FindOneById', null, query);
  }

  /**
   * 删除问题
   */
  export async function deleteByIds_POST(
    model: IdsModel,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/Problem/DeleteByIds', model, query);
  }

  /**
   * 标记问题是否已解决
   */
  export async function setSolvedState_POST(
    model: MarkProblemDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/Problem/SetSolvedState', model, query);
  }

  /**
   * 回复问题
   */
  export async function reply_POST(
    model: ReplyProblemDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/Problem/Reply', model, query);
  }

  /**
   * 手机端学员-录入&#x2F;编辑问题
   */
  export async function save_POST(
    model: ProblemDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/Problem/Save', model, query);
  }
}
// tslint:disable-next-line:no-namespace
export namespace Room {
  /**
   * 导入住宿房号信息
   */
  export async function importRoomInfo_POST(query: {
    /** 培训班类型 */

    classType?: TrainingClassType | undefined /** 培训班Id */;
    publicTrainingClassId?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/Room/ImportRoomInfo', null, query);
  }

  /**
   * 手机端-根据培训班id和姓名查找个人住宿安排信息
   */
  export async function findByClassIdAndName_GET(query: { classId?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Room/FindByClassIdAndName', null, query);
  }

  /**
   * 管理端-根据培训班ID查看当前培训班所有住宿安排信息
   */
  export async function findByClassId_GET(query: { classId?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Room/FindByClassId', null, query);
  }

  /**
   * 根据Id查找房间信息
   */
  export async function findOneById_GET(query: { id?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Room/FindOneById', null, query);
  }

  /**
   * 删除房间信息
   */
  export async function deleteByIds_POST(
    model: IdsModel,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/Room/DeleteByIds', model, query);
  }

  /**
   * 电脑端-录入&#x2F;编辑房间信息
   */
  export async function save_POST(
    model: StudentRoomDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/Room/Save', model, query);
  }
}
// tslint:disable-next-line:no-namespace
export namespace TeacherEvaluation {
  /**
   * 删除教师评价
   */
  export async function deletes_POST(
    model: BatchDeleteIdsModel,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TeacherEvaluation/Deletes', model, query);
  }

  /**
   * 保存&#x2F;修改教师评价信息
   */
  export async function save_POST(
    model: TeacherEvaluationDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TeacherEvaluation/Save', model, query);
  }

  /**
   * 获取所有教师评价信息
   */
  export async function findAll_GET(query: {
    /** 培训班名称 */

    className?: string | undefined /** 学生姓名 */;
    studentName?: string | undefined /** 教师姓名 */;
    teacherName?: string | undefined /** 课程名称 */;
    courseName?: string | undefined /** 日程安排id */;
    trainingSchedulingId?: string | undefined /** 教师id */;
    teacherId?: string | undefined /** 办班方案id */;
    openClassSolutionId?: string | undefined /** 学员id */;
    studentId?: string | undefined /** 培训班所属部门id */;
    deptId?: string | undefined /** 评价内容 */;
    content?: string | undefined /** pageIndex */;
    pageIndex?: number | undefined /** pageSize */;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TeacherEvaluation/FindAll', null, query);
  }

  /**
   * 根据培训班id获取教师评价信息
   */
  export async function getTeacherEvaluationByClassId_GET(query: {
    /** 教师id */

    classId?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>(
      'GET',
      '/api/TeacherEvaluation/GetTeacherEvaluationByClassId',
      null,
      query
    );
  }

  /**
   * 根据教师Id获取教师的评价信息
   */
  export async function getTeacherEvaluationById_GET(query: {
    /** 教师id */

    teacherId?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TeacherEvaluation/GetTeacherEvaluationById', null, query);
  }

  /**
   * 获取我的已评教师
   */
  export async function getMyCommented_GET(query: {
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TeacherEvaluation/GetMyCommented', null, query);
  }

  /**
   * 获取我的待评教师
   */
  export async function getMyWaitEvaluate_GET(query: {
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TeacherEvaluation/GetMyWaitEvaluate', null, query);
  }

  /**
   * 获取所有评价项目
   */
  export async function getEvaluateItems_GET(query?: { [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TeacherEvaluation/GetEvaluateItems', null, query);
  }

  /**
   * 根据id获取当前日程
   */
  export async function findOneById_GET(query: { id?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<TrainingScheduling>>('GET', '/api/TeacherEvaluation/FindOneById', null, query);
  }
}
// tslint:disable-next-line:no-namespace
export namespace Trainees {
  /**
   * 学员端个人微信解绑
   */
  export async function weixinUnbind_POST(
    model: IDModelString,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<boolean>>('POST', '/api/Trainees/WeixinUnbind', model, query);
  }

  /**
   * 电脑端微信解绑
   */
  export async function unbinding_POST(
    model: IDModel,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<boolean>>('POST', '/api/Trainees/Unbinding', model, query);
  }

  /**
   * 查询学员账号所有绑定微信
   */
  export async function findOpenIds_GET(query: { traineeId?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<TraineeOpenId[]>>('GET', '/api/Trainees/FindOpenIds', null, query);
  }

  /**
   * 修改学员部分信息
   */
  export async function edit_POST(
    model: StudentInfoDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/Trainees/Edit', model, query);
  }

  /**
   * 查询系统学员信息
   */
  export async function getList_GET(query: {
    /** 学员角色类型 */

    type?: UserType | undefined /** 姓名 */;
    name?: string | undefined /** 性别 */;
    sex?: string | undefined /** 手机号 */;
    phone?: string | undefined /** 工作单位 */;
    workUnit?: string | undefined /** 职务 */;
    job?: string | undefined /** 单位id */;
    deptId?: string | undefined /** 单位名称 */;
    deptName?: string | undefined /** 单位代码 */;
    deptCode?: string | undefined /** 民族 */;
    nation?: string | undefined /** 政治面貌 */;
    political?: string | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/Trainees/GetList', null, query);
  }
}
// tslint:disable-next-line:no-namespace
export namespace TrainingAgency {
  /**
   * 查询所有培训机构
   */
  export async function getAll_GET(query?: { name?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainingAgency/GetAll', null, query);
  }

  /**
   * 删除培训机构
   */
  export async function deletes_POST(
    model: BatchDeleteIdsModel,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TrainingAgency/Deletes', model, query);
  }

  /**
   * 新增&#x2F;编辑培训机构信息
   */
  export async function save_POST(
    model: TrainingAgencyDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TrainingAgency/Save', model, query);
  }
}
// tslint:disable-next-line:no-namespace
export namespace TrainRecords {
  export async function updateStringBirthday_GET(query?: { [key: string]: any }) {
    return apiSendAsync<ApiResponseData<string>>('GET', '/api/TrainRecords/UpdateStringBirthday', null, query);
  }

  /**
   * 录入编辑区管干部信息
   */
  export async function saveProvinceCadreInfo_POST(
    model: ProvinceCadreDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TrainRecords/SaveProvinceCadreInfo', model, query);
  }

  /**
   * 删除区管干部信息
   */
  export async function deleteProvinceCadres_POST(
    model: IdsModel,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TrainRecords/DeleteProvinceCadres', model, query);
  }

  /**
   * 查询区管干部信息
   */
  export async function findProvinceCadres_GET(query: {
    /** 单位id */

    deptId?: string | undefined /** 姓名 */;
    name?: string | undefined /** 性别 */;
    sex?: Sex | undefined /** 职务 */;
    job?: string | undefined /** 单位名称 */;
    org?: string | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/FindProvinceCadres', null, query);
  }

  /**
   * 录入编辑区管干部培训记录
   */
  export async function saveProvinceCadreTrainRecord_POST(
    model: ImportProvinceCadreTrainRecordDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TrainRecords/SaveProvinceCadreTrainRecord', model, query);
  }

  /**
   * 单位端或干教处查询区管干部培训记录
   */
  export async function findProvinceCadreTrainRecords_GET(query: {
    deptId?: string | undefined;
    provinceCadreId?: string | undefined;
    className?: string | undefined;
    job?: string | undefined;
    name?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/FindProvinceCadreTrainRecords', null, query);
  }

  /**
   * 干教处或单位端导入区管干部培训记录
   */
  export async function importProvinceCadreTrainRecords_POST(query?: { [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TrainRecords/ImportProvinceCadreTrainRecords', null, query);
  }

  /**
   * 补充各区直单位的培训班已扫码报到未产生的培训记录
   */
  export async function plugTrainRecords_POST(query?: { [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TrainRecords/PlugTrainRecords', null, query);
  }

  /**
   * 修改学员与培训记录部分信息
   */
  export async function updateTraineeInfo_POST(
    model: UpdateTraineeInfoDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TrainRecords/UpdateTraineeInfo', model, query);
  }

  /**
   * 干教处或单位端导入培训记录
   */
  export async function importTrainRecords_POST(query?: { [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TrainRecords/ImportTrainRecords', null, query);
  }

  /**
   * 干教管理端获取所有报道记录
   */
  export async function getRegisterRecords_GET(query: {
    /** 培训班名称 */

    className?: string | undefined /** 姓名 */;
    name?: string | undefined /** 电话 */;
    phone?: string | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/GetRegisterRecords', null, query);
  }

  /**
   * 导出学员报到情况表
   */
  export async function exportRegisterStudents_GET(query: {
    /** 培训班id */

    classId?: string | undefined /** 培训班类型 */;
    classType?: TrainingClassType | undefined /** 培训班名称 */;
    className?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/ExportRegisterStudents', null, query);
  }

  export async function getPhone_GET(query?: { phone?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<string>>('GET', '/api/TrainRecords/GetPhone', null, query);
  }

  /**
   * 根据培训班Id获取学员报道情况
   */
  export async function getBdResult_GET(query: { classId?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/GetBdResult', null, query);
  }

  /**
   * 根据用户id获取培训记录
   */
  export async function getUserTrainRecords_GET(query: { userId?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/GetUserTrainRecords', null, query);
  }

  /**
   * 导出某个培训班的培训记录
   */
  export async function exportTrainRecordsByClassId_GET(query: {
    /** 培训班id */

    classId?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/ExportTrainRecordsByClassId', null, query);
  }

  /**
   * 综合查询培训记录
   */
  export async function findTrainRecords_GET(query: {
    /** 是否导出 */

    isExport?: boolean | undefined /** 实际培训天数比较符 */;
    comparator?: Comparator | undefined /** 实际培训天数 */;
    days?: number | undefined /** 主管单位id */;
    deptId?: string | undefined /** 培训班名称 */;
    className?: string | undefined /** 民族 */;
    nation?: string | undefined /** 政治面貌 */;
    political?: string | undefined /** 职务 */;
    job?: string | undefined /** 工作单位 */;
    workUnit?: string | undefined /** 姓名 */;
    name?: string | undefined;
    phone?: string | undefined /** 开始培训时间 */;
    startTime?: string | undefined /** 截至培训时间 */;
    endTime?: string | undefined /** 职级比较符 */;
    rankComparator?: Comparator | undefined /** 管理岗职级 */;
    manageRank?: number | undefined /** 非管理岗职级 */;
    unManageRank?: number | undefined /** 性别 */;
    sex?: string | undefined /** 生日开始时间 */;
    startBirthDay?: string | undefined /** 生日截至时间 */;
    endBirthday?: string | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/FindTrainRecords', null, query);
  }

  /**
   * 获取单位树
   */
  export async function getOrgs_GET(query?: { [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/GetOrgs', null, query);
  }

  /**
   * 批量检测培训班是否已生成培训记录
   */
  export async function checkIsHaveTrainRecord_POST(
    model: IdsModel,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TrainRecords/CheckIsHaveTrainRecord', model, query);
  }

  /**
   * 批量检测培训班是否已报道
   */
  export async function checkIsSignin_POST(
    model: IdsModel,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TrainRecords/CheckIsSignin', model, query);
  }

  /**
   * 管理端取消报道操作
   */
  export async function manageCancel_POST(
    model: ClassSigninDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TrainRecords/ManageCancel', model, query);
  }

  /**
   * 取消报道
   */
  export async function cancelSignin_POST(
    model: ClassSigninDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TrainRecords/CancelSignin', model, query);
  }

  /**
   * 学员班级扫码报道接口
   */
  export async function classSignin_POST(
    model: ClassSigninDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TrainRecords/ClassSignin', model, query);
  }

  export async function findTraineeById_GET(query: { id?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/FindTraineeById', null, query);
  }

  /**
   * 获取培训层级配置数据
   */
  export async function getTrainingLevelData_GET(query?: { [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/GetTrainingLevelData', null, query);
  }

  /**
   * 录入培训记录查找学员 (单位管理端使用）
   */
  export async function findStudentsByDeptIdAndName_GET(query?: { name?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/FindStudentsByDeptIdAndName', null, query);
  }

  /**
   * 根据姓名查找学员
   */
  export async function findStudentsByName_GET(query?: { name?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/FindStudentsByName', null, query);
  }

  /**
   * 根据姓名查找新的学员信息
   */
  export async function findTraineesByName_GET(query?: { name?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/FindTraineesByName', null, query);
  }

  /**
   * 录入培训记录-查询培训班（干教或者单位录入培训记录；先选学员，再根据学员姓名和班级名称查询）
   */
  export async function findClassByName_GET(query?: {
    /** 培训班名称 */

    className?: string | undefined /** 学员姓名 */;
    studentName?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/FindClassByName', null, query);
  }

  /**
   * 干教处和单位端共用-批量审核培训申报记录
   */
  export async function batchAduit_POST(
    model: BatchAduitDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TrainRecords/BatchAduit', model, query);
  }

  /**
   * 干教处和单位端共用录入编辑培训记录
   */
  export async function deptSave_POST(
    model: TrainRecordDto,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TrainRecords/DeptSave', model, query);
  }

  /**
   * 学员手机端-录入编辑培训记录
   */
  export async function mobileSave_POST(query: {
    Type?: TrainRecordType | undefined;
    ClassName?: string | undefined;
    TrainType?: string | undefined;
    LocationCategory?: string | undefined;
    RunClassType?: string | undefined;
    Content?: string | undefined;
    Province?: string | undefined;
    City?: string | undefined;
    County?: string | undefined;
    Address?: string | undefined;
    StartDate?: string | undefined;
    EndDate?: string | undefined;
    Days?: number | undefined;
    TrainingLevel?: TrainingClassLevel | undefined;
    Organization?: string | undefined;
    Sponsor?: string | undefined;
    Teacher?: string | undefined;
    TeacherUnit?: string | undefined;
    TeacherPost?: string | undefined;
    TeacherPhone?: string | undefined;
    Certificate?: string | undefined;
    LostProof?: string | undefined;
    Id?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TrainRecords/MobileSave', null, query);
  }

  export async function saveTrainingLevelOrganization_GET(query?: {
    code?: string | undefined;
    organization?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/SaveTrainingLevelOrganization', null, query);
  }

  export async function recursion_GET(query?: {
    data?: TrainingLevelTree[] | undefined;
    code?: string | undefined;
    organization?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/Recursion', null, query);
  }

  /**
   * 干教处和单位端共用删除培训记录接口
   */
  export async function deletes_POST(
    model: BatchDeleteIdsModel,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TrainRecords/Deletes', model, query);
  }

  /**
   * 根据培训班id获取培训记录
   */
  export async function getTrainRecordsByClassId_GET(query: { classId?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/GetTrainRecordsByClassId', null, query);
  }

  /**
   * 向某个培训班补录学员的培训记录
   */
  export async function addRecordToStudent_POST(
    model: AddRecordToStudent,

    query?: {
      [key: string]: any;
    }
  ) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TrainRecords/AddRecordToStudent', model, query);
  }

  /**
   * 导入参加本期培训班培训的未报到学员(导入成功之后自动产生培训记录)
   */
  export async function importStudentsOfDept_POST(query: {
    classType?: TrainingClassType | undefined;
    publicTrainingClassId?: string | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('POST', '/api/TrainRecords/ImportStudentsOfDept', null, query);
  }

  /**
   * 根据id获取培训记录
   */
  export async function getTrainRecordById_GET(query: { id?: string | undefined; [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/GetTrainRecordById', null, query);
  }

  /**
   * 移动端-获取个人的培训记录
   */
  export async function getMyTrainRecords_GET(query?: { [key: string]: any }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/GetMyTrainRecords', null, query);
  }

  /**
   * 获取单位端培训记录
   */
  export async function getMyDeptRecords_GET(query: {
    /** 培训记录类型 */

    type?: TrainRecordType | undefined /** 干教处审核状态 */;
    auditState?: CommonAuditStatus | undefined /** 主管单位审核状态 */;
    orgAuditState?: CommonAuditStatus | undefined;
    className?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    trainType?: string | undefined;
    locationCategory?: string | undefined;
    runClassType?: string | undefined;
    province?: string | undefined;
    city?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    organization?: string | undefined;
    trainingLevel?: TrainingClassLevel | undefined;
    sponsor?: string | undefined /** 培训记录来源 全部-null  、补录-false、扫码报道-true */;
    isAuto?: boolean | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/GetMyDeptRecords', null, query);
  }

  /**
   * 干教管理端获取所有培训记录
   */
  export async function getAllTrainRecords_GET(query: {
    /** 培训记录类型 */

    type?: TrainRecordType | undefined;
    deptId?: string | undefined /** 干教处审核状态 */;
    auditState?: CommonAuditStatus | undefined /** 主管单位审核状态 */;
    orgAuditState?: CommonAuditStatus | undefined;
    className?: string | undefined;
    name?: string | undefined;
    phone?: string | undefined;
    trainType?: string | undefined;
    locationCategory?: string | undefined;
    runClassType?: string | undefined;
    province?: string | undefined;
    city?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    organization?: string | undefined;
    trainingLevel?: TrainingClassLevel | undefined;
    sponsor?: string | undefined /** 培训记录来源 全部-null  、补录-false、扫码报道-true */;
    isAuto?: boolean | undefined /** 是否全部培训记录（默认已过滤未有效的） */;
    isAll?: boolean | undefined;
    pageIndex?: number | undefined;
    pageSize?: number | undefined;
    [key: string]: any;
  }) {
    return apiSendAsync<ApiResponseData<any>>('GET', '/api/TrainRecords/GetAllTrainRecords', null, query);
  }
}

interface List<T> {
  [key: number]: T;
}
